//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { out_stock, stock_order } from "@/api/server";
import { wms_order_back } from "@/api/wms";
import orderDetail from "@/components/warehouse/order";
const obj = {
	APPLY: "申领",
	BORROW: "借用",
	BACK: "归还",
	PURCHASE: "入库",
	INVENTORY: "盘点"
};
export default {
	data() {
		return {
			userList: [],
			currentKey: "APPLY",
			filters: {
				status: null,
				product_name: null,
				user_id: null,
				checker_id: null,
			},
			list: {
				data: [],
				loading: false,
				page: 1,
				size: 10,
				total: 0
			},

			use_type_list: [
				{ id: "CLASSUSE", name: "班级使用" },
				{ id: "COMMON", name: "部门使用" },
				{ id: "ORTHER", name: "外借" },
				// { id: "SELFUSE", name: "自用" },
			],

			no: null,
			status_list1: [
				{ id: "PENDING ", name: "审核中" },
				{ id: "PICK", name: "待领物" },
				{ id: "COMPLETE", name: "已完成" },
				{ id: "CANCEL", name: "已撤回" },
				{ id: "REJECTED", name: "被驳回" }
			],
			status_list2: [
				{ id: "RETURNING", name: "正在归还" },
				{ id: "COMPLETE", name: "已完成" },
				{ id: "CANCEL", name: "已撤回" }
			]
		};
	},

	components: {
		orderDetail
	},

	methods: {
		cancelApply(data) {
			this.$confirm("撤销后不能重新提交，确定要撤销吗?", "提示", {
				confirmButtonText: "撤销",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					this.list.loading = true;
					let promise =
						data.type == "BACK"
							? wms_order_back.cancel({ id: data.id })
							: out_stock.cancelApply({ id: data.id });
					promise.then(res => {
						this.list.loading = false;
						if (res.data) {
							this.$message({
								message: "撤销成功！",
								type: "success"
							});
							this.getList();
						}
					});
				})
				.catch(() => { });
		},

		// 查看详情
		getDetail(data) {
			this.$refs.orderDetailRef.openOrder(data.id);
		},

		// 申请单记录
		getList() {
			let param = {
				page: this.list.page,
				size: this.list.size,
				type: this.currentKey
			};
			this.no ? (param.no = this.no) : null;
			this.filters.product_name = this.filters.product_name || null;
			param = Object.assign(param, this.filters);
			param.use_type = param.use_type || null
			this.list.loading = true;
			stock_order.paginate(param).then(res => {
				if (res.data) {
					this.list.loading = false;
					this.list.data = res.data.list;
					this.list.total = res.data.totalRow;
					if (this.list.data && this.list.data.length > 0) {
						this.list.data.forEach(v => {
							v.type_str = obj[v.type];
							v.status_str =
								v.status == "REJECTED"
									? "被驳回"
									: v.status == "PICK"
										? "待领物"
										: v.status == "COMPLETE"
											? "已完成"
											: v.status == "CANCEL"
												? "已撤回"
												: v.status == "COMMIT"
													? "待提交"
													: v.status == "CONFIRM"
														? "领物待确认"
														: v.status == "RETURNING"
															? "正在归还"
															: "审核中";
							v.status == "CONFIRM"
								? (v.status_str = "领物待确认")
								: "";
						});
					}
				}
			});
		},
		handleSizeChange(val) {
			this.list.size = val;
			this.getList();
		},
		handleCurrentChange(val) {
			this.list.page = val;
			this.getList();
		},

		handleClickTab() {
			this.list.page = 1;
			this.filters.status = null;
			this.filters.product_name = null;
			this.filters.user_id = null
			this.filters.use_type = null
			this.no = null;
			this.getList();
		}
	},

	mounted() {
		this.getList();
		out_stock.getAllUser().then(res => {
			if (res.data) {
				this.userList = res.data.schoolUserList;
			}
		});
	}
};



// WEBPACK FOOTER //
// ./src/views/warehouse/receive/order.vue